import { RefObject, useCallback, useRef } from 'react';
import { View } from 'react-vega';

export const useSignal = (viewRef: RefObject<View>) => {
  // runAsync needs to be awaited before it is allowed to be called again.
  const promiseRef = useRef<Promise<View | void>>(Promise.resolve());

  return useCallback(
    (name: string, value: unknown) => {
      promiseRef.current = promiseRef.current
        .then(() => {
          viewRef.current?.signal(name, value);

          return viewRef.current?.runAsync();
        })
        .finally(() => {
          globalThis.dispatchEvent(new CustomEvent('resizevegachart'));
        });
    },
    [viewRef]
  );
};
